import { apiUrl } from '@configs/environment';
import httpClient from '@shared/api/httpClient';
import { StartEvalData } from '../interfaces/StartEvalData';

export const startSelectedEvals = ({ evaluationId, eraseFeedbacks }: StartEvalData): Promise<void> =>
  httpClient
    .post<void>(`${apiUrl}/evaluations/${evaluationId}/start/`, { erase_feedbacks: eraseFeedbacks })
    .then(({ data }) => data);
